import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export interface ITransportMileageFilter {
  date?: Dayjs[];
  subcontractor?: 'none' | 'any' | number[];
}

type TState = {
  filters?: ITransportMileageFilter;
  search?: string;
};

type TActions = {
  setFilters: (value: ITransportMileageFilter | undefined) => void;
  setSearch: (value: string) => void;
};

export const useTransportMileageFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE },
    setFilters: (filters: ITransportMileageFilter | undefined) => set((state) => ({ ...state, filters })),
    setSearch: (search: string) => set((state) => ({ ...state, search })),
  }),
  'transport-mileage-filters-store',
);
